import * as React from "react";
const SvgFiRrDreidel = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-dreidel_svg__a)">
      <path
        fill="#062147"
        d="M23.707.293a1 1 0 0 0-1.414 0L14.96 7.626 13.8 6.465a5.01 5.01 0 0 0-7.067-.006l-5.268 5.188A4.97 4.97 0 0 0 0 15.184V19a5.006 5.006 0 0 0 5 5h3.816a4.98 4.98 0 0 0 3.542-1.47l5.177-5.258a5.006 5.006 0 0 0 0-7.071L16.374 9.04l7.333-7.333a1 1 0 0 0 0-1.414M2 19v-3.14A6.47 6.47 0 0 0 5.442 17a8 8 0 0 0 1.732-.182A8 8 0 0 0 7 18.5 6.6 6.6 0 0 0 8.15 22H5a3 3 0 0 1-3-3m14.115-3.137-5.177 5.258a3 3 0 0 1-.585.457A5.04 5.04 0 0 1 9 18.5a4.39 4.39 0 0 1 1.128-3.214l2.579-2.58a1 1 0 0 0-1.414-1.413l-2.579 2.579A4.55 4.55 0 0 1 5.442 15a4.85 4.85 0 0 1-3.023-1.35 3 3 0 0 1 .455-.583l5.268-5.188a3 3 0 0 1 4.243 0l3.736 3.736a3 3 0 0 1-.006 4.248"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-dreidel_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrDreidel;
